import { createContext, useContext, useEffect, useState } from "react";

const KEY = "g1_access_token";
const EXP_KEY = "g1_access_exp";

const Ctx = createContext({
  unlocked: false,
  loading: true,
  grant: () => {},
  revoke: () => {},
});

export const AccessProvider = ({ children }) => {
  const [unlocked, setUnlocked] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const token = localStorage.getItem(KEY);
      const exp = parseInt(localStorage.getItem(EXP_KEY) || "0", 10);
      if (token && exp > Date.now() / 1000) {
        setUnlocked(true);
      } else if (token) {
        // expired
        localStorage.removeItem(KEY);
        localStorage.removeItem(EXP_KEY);
      }
    } catch (e) {
      // ignore
    }
    setLoading(false);
  }, []);

  const grant = ({ token, expires_in }) => {
    try {
      localStorage.setItem(KEY, token);
      localStorage.setItem(
        EXP_KEY,
        String(Math.floor(Date.now() / 1000) + expires_in)
      );
    } catch (e) {
      // ignore storage errors
    }
    setUnlocked(true);
  };

  const revoke = () => {
    try {
      localStorage.removeItem(KEY);
      localStorage.removeItem(EXP_KEY);
    } catch (e) {
      // ignore
    }
    setUnlocked(false);
  };

  return (
    <Ctx.Provider value={{ unlocked, loading, grant, revoke }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAccess = () => useContext(Ctx);
